const TYPE_CITIES = '(cities)';
const TYPE_GEOCODE = 'geocode';
export {
  TYPE_GEOCODE,
  TYPE_CITIES,
};
